(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["gn-gallery-settings"] && !Shopify.designMode) return;
  try {
    // Optional sharp thumbnail sources. Scope: this product section only.
  // No cart, variant, payment, native carousel or zoom behavior is replaced.
  if (!customElements.get('gn-gallery-settings')) {
    customElements.define('gn-gallery-settings', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.upgrade !== 'true') return;
        this.root = document.getElementById('shopify-section-' + this.dataset.section);
        if (!this.root) return;
        this.queue = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = 0; this.upgrade(); });
        };
        this.observer = new MutationObserver(this.queue);
        this.observer.observe(this.root, {childList:true, subtree:true});
        window.addEventListener('resize', this.queue, {passive:true});
        this.queue();
      }
      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.queue) window.removeEventListener('resize', this.queue);
        if (this.frame) cancelAnimationFrame(this.frame);
      }
      upgrade() {
        if (!this.root || !this.isConnected) return;
        this.root.querySelectorAll('media-gallery .slideshow-controls__thumbnail img').forEach((img) => {
          try {
            const raw = img.getAttribute('src');
            if (!raw) return;
            const source = new URL(raw, location.href);
            const isShopify = source.hostname === 'cdn.shopify.com' || source.hostname.endsWith('.shopifycdn.com') || (source.origin === location.origin && source.pathname.includes('/cdn/shop/'));
            if (!isShopify || !source.searchParams.has('width')) return;
            const tile = img.closest('.slideshow-controls__thumbnail');
            const width = Math.ceil(tile.getBoundingClientRect().width);
            if (!width) return;
            const sizes = width + 'px';
            if (img.dataset.gnpSize === sizes) return;
            const candidates = [160,320,480,640];
            img.setAttribute('sizes', sizes);
            img.setAttribute('srcset', candidates.map((w) => {
              const candidate = new URL(source); candidate.searchParams.set('width',String(w));
              return candidate.href + ' ' + w + 'w';
            }).join(', '));
            const src = new URL(source); src.searchParams.set('width',String(Math.min(640,Math.max(320,width*2))));
            img.setAttribute('src',src.href);
            img.dataset.gnpSize = sizes;
          } catch (_) { /* Leave unsupported/custom image URLs unchanged. */ }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["gn-pdp-sale"] && !Shopify.designMode) return;
  try {
    /* Enhances only the badge, never the native price, variant picker or cart.
   It reuses the section HTML already fetched by Horizon. No variant-array limit,
   no parsing of formatted currency, and no extra network request for product data.
   Current StandardEvents and older ThemeEvents are detected, not assumed.
   If a theme revision has no compatible event, hide on selection (never stale). */
if (!customElements.get('gn-pdp-sale')) {
  class GNPdpSale extends HTMLElement {
    connectedCallback() {
      this._controller?.abort();
      this._controller = new AbortController();
      this._section = this.closest('.shopify-section');
      this._version = 0;
      if (!this._section) return;
      const signal = this._controller.signal;
      this._section.addEventListener('change', (event) => {
        if (event.target instanceof Element && event.target.closest('variant-picker')) {
          this._version += 1;
          this.hidden = true;
        }
      }, {capture: true, signal});
      const types = new Set();
      const bind = (name) => {
        if (!name || signal.aborted || types.has(name)) return;
        types.add(name);
        this._section.addEventListener(name, this._onUpdate, {signal});
      };
      import('@shopify/events').then(m => bind(m.StandardEvents?.productSelect)).catch(() => {});
      import('@theme/events').then(m => {
        bind(m.ThemeEvents?.variantUpdate);
        const selected = m.ThemeEvents?.variantChange;
        if (selected && !signal.aborted) {
          this._section.addEventListener(selected, () => {
            this._version += 1;
            this.hidden = true;
          }, {signal});
        }
      }).catch(() => {});
    }
    disconnectedCallback() {
      this._version += 1;
      this._controller?.abort();
    }
    _onUpdate = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
      if (event.target.closest('.shopify-section') !== this._section) return;
      const version = ++this._version;
      this.hidden = true;
      const apply = (payload) => {
        if (!this.isConnected || version !== this._version) return;
        const detail = payload?.detail || payload;
        let doc = detail?.html || detail?.data?.html;
        if (typeof doc === 'string') doc = new DOMParser().parseFromString(doc, 'text/html');
        if (!doc?.querySelectorAll) return;
        const fresh = Array.from(doc.querySelectorAll('gn-pdp-sale')).find(el => el.dataset.blockId === this.dataset.blockId);
        if (!fresh) return;
        this.innerHTML = fresh.innerHTML;
        this.dataset.productId = fresh.dataset.productId || '';
        this.hidden = fresh.hasAttribute('hidden');
      };
      if (event.promise && typeof event.promise.then === 'function') {
        event.promise.then(apply).catch(() => {});
      } else {
        apply(event.detail);
      }
    };
  }
  customElements.define('gn-pdp-sale', GNPdpSale);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["gn-product-panel"] && !Shopify.designMode) return;
  try {
    // Opening a nested item in Shopify's editor also reveals its parent panels.
  if (!window.gnProductPanelEditorBound) {
    window.gnProductPanelEditorBound = true;
    document.addEventListener('shopify:block:select', (event) => {
      let node = event.target;
      while (node && node !== document.body) {
        if (node.matches && node.matches('details[data-gn-details]')) node.open = true;
        if (node.matches && node.matches('.gnp-detail-panel')) {
          const details = node.querySelector('details[data-gn-details]');
          if (details) details.open = true;
        }
        node = node.parentElement;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["gn-produktfamilie"] && !Shopify.designMode) return;
  try {
    // Normale Shopify-Produktlinks bleiben echte Links (kein Variant Picker).
  // Nur die optionale Dropdown-Darstellung benoetigt Navigation per JS.
  document.addEventListener('change', (event) => {
    const field = event.target;
    if (!field?.matches?.('gn-product-family [data-gn-family-select]')) return;
    const url = field.value;
    if (url.startsWith('/') && !url.startsWith('//')) {
      window.location.assign(url);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["gnb-topper-interaktiv"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gn-topper-advisor')) {
  class GNTopperAdvisor extends HTMLElement {
    connectedCallback() {
      if (this.dataset.gnBound === 'true') return;
      this.dataset.gnBound = 'true';

      this.slidesWrap = this.querySelector('.gnta__slides');
      this.slides = Array.from(this.querySelectorAll('.gn-topper-slide'));
      this.currentSlide = 0;
      this.isAnimating = false;
      this.slideDuration = 420;

      this.addEventListener('click', (event) => {
        const prev = event.target.closest('[data-gnta-prev]');
        const next = event.target.closest('[data-gnta-next]');
        const flip = event.target.closest('[data-gnta-flip]');
        const sideButton = event.target.closest('[data-gnta-side]');

        if (prev) {
          event.preventDefault();
          this.showSlide(this.currentSlide - 1, 'prev');
          return;
        }

        if (next) {
          event.preventDefault();
          this.showSlide(this.currentSlide + 1, 'next');
          return;
        }

        if (sideButton) {
          event.preventDefault();
          const slide = sideButton.closest('.gn-topper-slide');
          this.setSide(slide, sideButton.dataset.gntaSide);
          return;
        }

        if (flip) {
          const slide = flip.closest('.gn-topper-slide');
          if (!slide || slide.dataset.reversible !== 'true') return;

          event.preventDefault();
          const nextSide = slide.dataset.activeSide === 'b' ? 'a' : 'b';
          this.setSide(slide, nextSide);
        }
      });

      this.addEventListener('shopify:block:select', (event) => {
        const slide = event.target.closest('.gn-topper-slide');
        if (!slide) return;

        const index = this.slides.indexOf(slide);
        if (index >= 0) this.showSlide(index, index > this.currentSlide ? 'next' : 'prev');
      });

      this.slides.forEach((slide) => {
        if (!slide.dataset.activeSide) slide.dataset.activeSide = 'a';
        this.setSide(slide, slide.dataset.activeSide, false);
      });

      this.showSlide(0, 'next', false);
      this.dataset.ready = 'true';

      window.addEventListener('resize', () => this.syncHeight());
      requestAnimationFrame(() => this.syncHeight());
    }

    syncHeight() {
      if (!this.slidesWrap || !this.slides.length) return;
      const active = this.slides[this.currentSlide];
      if (!active) return;
      this.slidesWrap.style.height = active.offsetHeight + 'px';
    }

    showSlide(index, direction = 'next', animate = true) {
      if (!this.slides.length || this.isAnimating) return;

      const total = this.slides.length;
      const nextIndex = (index + total) % total;
      const current = this.slides[this.currentSlide];
      const next = this.slides[nextIndex];

      if (!next) return;
      if (current === next) {
        this.currentSlide = nextIndex;
        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === nextIndex;
          slide.classList.toggle('is-active', active);
          slide.classList.remove('is-entering', 'is-leaving');
          slide.style.transform = '';
          slide.style.opacity = active ? '1' : '0';
          slide.style.pointerEvents = active ? 'auto' : 'none';
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          const counter = slide.querySelector('[data-gnta-counter]');
          if (counter) counter.textContent = `${slideIndex + 1} / ${total}`;
        });
        this.syncHeight();
        return;
      }

      this.currentSlide = nextIndex;
      this.slides.forEach((slide, slideIndex) => {
        const counter = slide.querySelector('[data-gnta-counter]');
        if (counter) counter.textContent = `${slideIndex + 1} / ${total}`;
      });

      if (!animate || !current) {
        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === nextIndex;
          slide.classList.toggle('is-active', active);
          slide.classList.remove('is-entering', 'is-leaving');
          slide.style.transform = '';
          slide.style.opacity = active ? '1' : '0';
          slide.style.pointerEvents = active ? 'auto' : 'none';
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        this.syncHeight();
        return;
      }

      this.isAnimating = true;

      const offset = direction === 'prev' ? '-56px' : '56px';
      const leaveOffset = direction === 'prev' ? '56px' : '-56px';
      const nextHeight = next.offsetHeight;
      this.slidesWrap.style.height = Math.max(current.offsetHeight, nextHeight) + 'px';

      next.classList.add('is-entering');
      next.classList.remove('is-active', 'is-leaving');
      next.style.transform = `translateX(${offset})`;
      next.style.opacity = '0';
      next.style.pointerEvents = 'none';
      next.setAttribute('aria-hidden', 'false');

      current.classList.add('is-leaving');
      current.classList.remove('is-active', 'is-entering');
      current.style.transform = 'translateX(0)';
      current.style.opacity = '1';
      current.style.pointerEvents = 'none';
      current.setAttribute('aria-hidden', 'true');

      requestAnimationFrame(() => {
        next.style.transition = `transform ${this.slideDuration}ms cubic-bezier(.22,.61,.36,1), opacity ${this.slideDuration}ms ease`;
        current.style.transition = `transform ${this.slideDuration}ms cubic-bezier(.22,.61,.36,1), opacity ${this.slideDuration}ms ease`;

        next.style.transform = 'translateX(0)';
        next.style.opacity = '1';
        current.style.transform = `translateX(${leaveOffset})`;
        current.style.opacity = '0';
      });

      window.setTimeout(() => {
        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === nextIndex;
          slide.classList.toggle('is-active', active);
          slide.classList.remove('is-entering', 'is-leaving');
          slide.style.transition = '';
          slide.style.transform = '';
          slide.style.opacity = active ? '1' : '0';
          slide.style.pointerEvents = active ? 'auto' : 'none';
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        this.isAnimating = false;
        this.syncHeight();
      }, this.slideDuration + 30);
    }

    setSide(slide, side, animate = true) {
      if (!slide) return;
      if (slide.dataset.reversible !== 'true') side = 'a';

      slide.dataset.activeSide = side;

      const rotator = slide.querySelector('.gn-topper-visual__rotator');
      if (rotator) {
        if (!animate) rotator.style.transition = 'none';
        rotator.classList.toggle('is-flipped', side === 'b');

        if (!animate) {
          requestAnimationFrame(() => {
            rotator.style.transition = '';
          });
        }
      }

      slide.querySelectorAll('[data-gnta-side]').forEach((button) => {
        button.setAttribute(
          'aria-pressed',
          button.dataset.gntaSide === side ? 'true' : 'false'
        );
      });

      slide.querySelectorAll('[data-gnta-info]').forEach((panel) => {
        panel.hidden = panel.dataset.gntaInfo !== side;
      });

      this.syncHeight();
    }
  }

  customElements.define('gn-topper-advisor', GNTopperAdvisor);
}
  } catch(e) { console.error(e); }
})();

})();
